import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const items = [
  { to: "/analytics", key: "nav.home", end: true },
  { to: "/analytics/faculties", key: "nav.faculties" },
  { to: "/analytics/directions", key: "nav.directions" },
  { to: "/analytics/groups", key: "nav.groups" },
  { to: "/analytics/subjects", key: "nav.subjects" },
  { to: "/analytics/people", key: "nav.people" },
  { to: "/analytics/exams", key: "nav.exams" },
  { to: "/analytics/practices", key: "nav.practices" },
  { to: "/analytics/auditoriums", key: "nav.auditoriums" },
];

/** Пункт меню нового раздела «Аналитика» — раскрыт по умолчанию, выше старого раздела. */
const SidebarAnalyticsNew: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(true);
  const isActive = location.pathname.startsWith("/analytics");

  return (
    <>
      <div
        className={`link-item-style d-flex justify-content-between align-items-center ${
          isActive ? "active-menu" : ""
        }`}
        onClick={() => setOpen(!open)}
      >
        <span>
          <span className="icon icon-analitcs" />
          <span className="menu-item-style font-family-openSans-SemiBold">
            {t("common.analyticsNew.section")}
          </span>
        </span>
        <span
          className={`icon ${open ? "icon-chevronup" : "icon-chevronup icon-chevrondown"}`}
        />
      </div>

      {open && (
        <div>
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className="link-item-style-child"
            >
              {t(`common.analyticsNew.${item.key}`)}
            </NavLink>
          ))}
        </div>
      )}
    </>
  );
};

export default SidebarAnalyticsNew;
